import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Subscription } from 'rxjs';
import { CatalogueService } from 'src/app/provider/catalogue.service';
import { ItemService } from 'src/app/provider/item.service';
import { PromotionService } from 'src/app/provider/promotion.service';
import { NewPromotionComponent } from '../popup/new-promotion/new-promotion.component';

@Component({
  selector: 'kt-product-promotion',
  templateUrl: './product-promotion.component.html',
  styleUrls: ['./product-promotion.component.scss']
})
export class ProductPromotionComponent implements OnInit, OnChanges, OnDestroy {

  @Input() ID: number;

  subs: Subscription[] = [];

  constructor(
    public itemService: ItemService,
    private changeDetect: ChangeDetectorRef,
    private matDialog: MatDialog,
    private catalogServ: CatalogueService,
    public promotionServ: PromotionService
  ) {
  }

  async ngOnInit() {
    this.catalogServ.menuItemId = this.ID;
    await this.promotionServ.getPromotions();
    this.changeDetect.detectChanges();
  }

  async ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;

    this.catalogServ.menuItemId = this.ID;
    await this.promotionServ.getPromotions();
    this.changeDetect.detectChanges();
    this.itemService.getData(this.ID, 'menu-item');

    this.itemService.record_change$.subscribe(async (resp) => {
      this.changeDetect.detectChanges();
    });
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  onChange() {
    const data = this.itemService.record_change$.getValue();
    this.itemService.putItem(data);
  }

  newPromotion() {
    const MODAL = this.matDialog.open(NewPromotionComponent, {
      width: '70vw'
    });
  }

  async deletePromotion(id: number) {
    await this.promotionServ.deletePromotion(id);
    this.changeDetect.detectChanges();
  }

}
